// extracted by mini-css-extract-plugin
export default {"mainWrapper":"product-list_mainWrapper__mwYu3","header":"product-list_header__dRYsI","documentNameWrapper":"product-list_documentNameWrapper__Ul5px"};